export class TableQuickViewColumnDTO {
  linkText: string
  linkData: any
  selected: boolean
}
